/* eslint-disable */
// source: subscription.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.billing.private.subscription.Addon', null, global);
goog.exportSymbol('proto.billing.private.subscription.AddonPriceModel', null, global);
goog.exportSymbol('proto.billing.private.subscription.AddonPriceSimulation', null, global);
goog.exportSymbol('proto.billing.private.subscription.Allowance', null, global);
goog.exportSymbol('proto.billing.private.subscription.AllowancePriceModel', null, global);
goog.exportSymbol('proto.billing.private.subscription.AllowancePriceSimulation', null, global);
goog.exportSymbol('proto.billing.private.subscription.CancelSubscriptionRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.CancelSubscriptionResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.CheckoutAddonsSimulationRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.CheckoutAddonsSimulationResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.CheckoutAllowancesSimulationRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.CheckoutAllowancesSimulationResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.Currency', null, global);
goog.exportSymbol('proto.billing.private.subscription.DeleteSubscriptionAddonRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.DeleteSubscriptionAddonResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.FrequencyType', null, global);
goog.exportSymbol('proto.billing.private.subscription.GetAddonsRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.GetAddonsResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.GetAllowancesRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.GetAllowancesResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.GetCancellationDetailsRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.GetCancellationDetailsResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.PricingModelType', null, global);
goog.exportSymbol('proto.billing.private.subscription.SubscriptionAddon', null, global);
goog.exportSymbol('proto.billing.private.subscription.SubscriptionStatus', null, global);
goog.exportSymbol('proto.billing.private.subscription.UnitTier', null, global);
goog.exportSymbol('proto.billing.private.subscription.UpdateSubscriptionAddonsRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.UpdateSubscriptionAddonsResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse', null, global);
goog.exportSymbol('proto.billing.private.subscription.UpdateSubscriptionStatusRequest', null, global);
goog.exportSymbol('proto.billing.private.subscription.UpdateSubscriptionStatusResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.DeleteSubscriptionAddonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.DeleteSubscriptionAddonRequest.displayName = 'proto.billing.private.subscription.DeleteSubscriptionAddonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.DeleteSubscriptionAddonResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.DeleteSubscriptionAddonResponse.displayName = 'proto.billing.private.subscription.DeleteSubscriptionAddonResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.GetAddonsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.GetAddonsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.GetAddonsRequest.displayName = 'proto.billing.private.subscription.GetAddonsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.GetAddonsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.GetAddonsResponse.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.GetAddonsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.GetAddonsResponse.displayName = 'proto.billing.private.subscription.GetAddonsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.CancelSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.CancelSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.CancelSubscriptionRequest.displayName = 'proto.billing.private.subscription.CancelSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.CancelSubscriptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.CancelSubscriptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.CancelSubscriptionResponse.displayName = 'proto.billing.private.subscription.CancelSubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.GetCancellationDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.GetCancellationDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.GetCancellationDetailsRequest.displayName = 'proto.billing.private.subscription.GetCancellationDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.GetCancellationDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.GetCancellationDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.GetCancellationDetailsResponse.displayName = 'proto.billing.private.subscription.GetCancellationDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.Addon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.Addon.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.Addon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.Addon.displayName = 'proto.billing.private.subscription.Addon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.AddonPriceModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.AddonPriceModel.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.AddonPriceModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.AddonPriceModel.displayName = 'proto.billing.private.subscription.AddonPriceModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UnitTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.UnitTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UnitTier.displayName = 'proto.billing.private.subscription.UnitTier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.UpdateSubscriptionAddonsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.displayName = 'proto.billing.private.subscription.UpdateSubscriptionAddonsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.UpdateSubscriptionAddonsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.displayName = 'proto.billing.private.subscription.UpdateSubscriptionAddonsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.SubscriptionAddon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.SubscriptionAddon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.SubscriptionAddon.displayName = 'proto.billing.private.subscription.SubscriptionAddon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.CheckoutAddonsSimulationRequest.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.CheckoutAddonsSimulationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.CheckoutAddonsSimulationRequest.displayName = 'proto.billing.private.subscription.CheckoutAddonsSimulationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.CheckoutAddonsSimulationResponse.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.CheckoutAddonsSimulationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.CheckoutAddonsSimulationResponse.displayName = 'proto.billing.private.subscription.CheckoutAddonsSimulationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.AddonPriceSimulation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.AddonPriceSimulation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.AddonPriceSimulation.displayName = 'proto.billing.private.subscription.AddonPriceSimulation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.CheckoutAllowancesSimulationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.displayName = 'proto.billing.private.subscription.CheckoutAllowancesSimulationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.CheckoutAllowancesSimulationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.displayName = 'proto.billing.private.subscription.CheckoutAllowancesSimulationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.AllowancePriceSimulation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.AllowancePriceSimulation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.AllowancePriceSimulation.displayName = 'proto.billing.private.subscription.AllowancePriceSimulation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.displayName = 'proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.displayName = 'proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.displayName = 'proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.displayName = 'proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.GetAllowancesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.GetAllowancesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.GetAllowancesRequest.displayName = 'proto.billing.private.subscription.GetAllowancesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.GetAllowancesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.GetAllowancesResponse.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.GetAllowancesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.GetAllowancesResponse.displayName = 'proto.billing.private.subscription.GetAllowancesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.Allowance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.Allowance.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.Allowance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.Allowance.displayName = 'proto.billing.private.subscription.Allowance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.AllowancePriceModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.subscription.AllowancePriceModel.repeatedFields_, null);
};
goog.inherits(proto.billing.private.subscription.AllowancePriceModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.AllowancePriceModel.displayName = 'proto.billing.private.subscription.AllowancePriceModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.Currency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.Currency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.Currency.displayName = 'proto.billing.private.subscription.Currency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.UpdateSubscriptionStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UpdateSubscriptionStatusRequest.displayName = 'proto.billing.private.subscription.UpdateSubscriptionStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.subscription.UpdateSubscriptionStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.subscription.UpdateSubscriptionStatusResponse.displayName = 'proto.billing.private.subscription.UpdateSubscriptionStatusResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.DeleteSubscriptionAddonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    addonId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestedByUserId: (f = msg.getRequestedByUserId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.DeleteSubscriptionAddonRequest;
  return proto.billing.private.subscription.DeleteSubscriptionAddonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddonId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRequestedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.DeleteSubscriptionAddonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAddonId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRequestedByUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 addon_id = 3;
 * @return {number}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.getAddonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.setAddonId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value requested_by_user_id = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.getRequestedByUserId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} returns this
*/
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.clearRequestedByUserId = function() {
  return this.setRequestedByUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonRequest.prototype.hasRequestedByUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.DeleteSubscriptionAddonResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAddonResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonResponse}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.DeleteSubscriptionAddonResponse;
  return proto.billing.private.subscription.DeleteSubscriptionAddonResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAddonResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAddonResponse}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.DeleteSubscriptionAddonResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAddonResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAddonResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.GetAddonsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.GetAddonsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.GetAddonsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAddonsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.GetAddonsRequest}
 */
proto.billing.private.subscription.GetAddonsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.GetAddonsRequest;
  return proto.billing.private.subscription.GetAddonsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.GetAddonsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.GetAddonsRequest}
 */
proto.billing.private.subscription.GetAddonsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.GetAddonsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.GetAddonsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.GetAddonsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAddonsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.GetAddonsRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetAddonsRequest} returns this
 */
proto.billing.private.subscription.GetAddonsRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.GetAddonsRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetAddonsRequest} returns this
 */
proto.billing.private.subscription.GetAddonsRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.GetAddonsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.GetAddonsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.GetAddonsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.GetAddonsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAddonsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addonsList: jspb.Message.toObjectList(msg.getAddonsList(),
    proto.billing.private.subscription.Addon.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.GetAddonsResponse}
 */
proto.billing.private.subscription.GetAddonsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.GetAddonsResponse;
  return proto.billing.private.subscription.GetAddonsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.GetAddonsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.GetAddonsResponse}
 */
proto.billing.private.subscription.GetAddonsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.subscription.Addon;
      reader.readMessage(value,proto.billing.private.subscription.Addon.deserializeBinaryFromReader);
      msg.addAddons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.GetAddonsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.GetAddonsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.GetAddonsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAddonsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billing.private.subscription.Addon.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Addon addons = 1;
 * @return {!Array<!proto.billing.private.subscription.Addon>}
 */
proto.billing.private.subscription.GetAddonsResponse.prototype.getAddonsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.Addon>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.Addon, 1));
};


/**
 * @param {!Array<!proto.billing.private.subscription.Addon>} value
 * @return {!proto.billing.private.subscription.GetAddonsResponse} returns this
*/
proto.billing.private.subscription.GetAddonsResponse.prototype.setAddonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billing.private.subscription.Addon=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.Addon}
 */
proto.billing.private.subscription.GetAddonsResponse.prototype.addAddons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing.private.subscription.Addon, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.GetAddonsResponse} returns this
 */
proto.billing.private.subscription.GetAddonsResponse.prototype.clearAddonsList = function() {
  return this.setAddonsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.CancelSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.CancelSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CancelSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    issueRefund: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.CancelSubscriptionRequest}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.CancelSubscriptionRequest;
  return proto.billing.private.subscription.CancelSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.CancelSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.CancelSubscriptionRequest}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssueRefund(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.CancelSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.CancelSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CancelSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIssueRefund();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.CancelSubscriptionRequest} returns this
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.CancelSubscriptionRequest} returns this
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool issue_refund = 4;
 * @return {boolean}
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.getIssueRefund = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.CancelSubscriptionRequest} returns this
 */
proto.billing.private.subscription.CancelSubscriptionRequest.prototype.setIssueRefund = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.CancelSubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.CancelSubscriptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.CancelSubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CancelSubscriptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.CancelSubscriptionResponse}
 */
proto.billing.private.subscription.CancelSubscriptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.CancelSubscriptionResponse;
  return proto.billing.private.subscription.CancelSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.CancelSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.CancelSubscriptionResponse}
 */
proto.billing.private.subscription.CancelSubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.CancelSubscriptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.CancelSubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.CancelSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CancelSubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.GetCancellationDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.GetCancellationDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.GetCancellationDetailsRequest}
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.GetCancellationDetailsRequest;
  return proto.billing.private.subscription.GetCancellationDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.GetCancellationDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.GetCancellationDetailsRequest}
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.GetCancellationDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.GetCancellationDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsRequest} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsRequest} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.GetCancellationDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.GetCancellationDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    refundAmount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    refundAmountFormatted: jspb.Message.getFieldWithDefault(msg, 2, ""),
    billingCurrency: jspb.Message.getFieldWithDefault(msg, 3, ""),
    unusedTimeStartDate: (f = msg.getUnusedTimeStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    unusedTimeEndDate: (f = msg.getUnusedTimeEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.GetCancellationDetailsResponse;
  return proto.billing.private.subscription.GetCancellationDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.GetCancellationDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRefundAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefundAmountFormatted(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingCurrency(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUnusedTimeStartDate(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUnusedTimeEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.GetCancellationDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.GetCancellationDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefundAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRefundAmountFormatted();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBillingCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnusedTimeStartDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnusedTimeEndDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 refund_amount = 1;
 * @return {number}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.getRefundAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.setRefundAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string refund_amount_formatted = 2;
 * @return {string}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.getRefundAmountFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.setRefundAmountFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string billing_currency = 3;
 * @return {string}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.getBillingCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.setBillingCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp unused_time_start_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.getUnusedTimeStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
*/
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.setUnusedTimeStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.clearUnusedTimeStartDate = function() {
  return this.setUnusedTimeStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.hasUnusedTimeStartDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp unused_time_end_date = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.getUnusedTimeEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
*/
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.setUnusedTimeEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.GetCancellationDetailsResponse} returns this
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.clearUnusedTimeEndDate = function() {
  return this.setUnusedTimeEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.GetCancellationDetailsResponse.prototype.hasUnusedTimeEndDate = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.Addon.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.Addon.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.Addon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.Addon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.Addon.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    quantityNext: (f = msg.getQuantityNext()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    addedOn: (f = msg.getAddedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    willBeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isForced: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    pricingModelType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    addOnPriceModelsList: jspb.Message.toObjectList(msg.getAddOnPriceModelsList(),
    proto.billing.private.subscription.AddonPriceModel.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.Addon}
 */
proto.billing.private.subscription.Addon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.Addon;
  return proto.billing.private.subscription.Addon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.Addon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.Addon}
 */
proto.billing.private.subscription.Addon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setQuantityNext(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAddedOn(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWillBeDeleted(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsForced(value);
      break;
    case 8:
      var value = /** @type {!proto.billing.private.subscription.PricingModelType} */ (reader.readEnum());
      msg.setPricingModelType(value);
      break;
    case 9:
      var value = new proto.billing.private.subscription.AddonPriceModel;
      reader.readMessage(value,proto.billing.private.subscription.AddonPriceModel.deserializeBinaryFromReader);
      msg.addAddOnPriceModels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.Addon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.Addon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.Addon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.Addon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getQuantityNext();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getAddedOn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWillBeDeleted();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsForced();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPricingModelType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAddOnPriceModelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.billing.private.subscription.AddonPriceModel.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.billing.private.subscription.Addon.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billing.private.subscription.Addon.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.billing.private.subscription.Addon.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value quantity_next = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.Addon.prototype.getQuantityNext = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.Addon} returns this
*/
proto.billing.private.subscription.Addon.prototype.setQuantityNext = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.clearQuantityNext = function() {
  return this.setQuantityNext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.Addon.prototype.hasQuantityNext = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp added_on = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.subscription.Addon.prototype.getAddedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.subscription.Addon} returns this
*/
proto.billing.private.subscription.Addon.prototype.setAddedOn = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.clearAddedOn = function() {
  return this.setAddedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.Addon.prototype.hasAddedOn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool will_be_deleted = 6;
 * @return {boolean}
 */
proto.billing.private.subscription.Addon.prototype.getWillBeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.setWillBeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_forced = 7;
 * @return {boolean}
 */
proto.billing.private.subscription.Addon.prototype.getIsForced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.setIsForced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional PricingModelType pricing_model_type = 8;
 * @return {!proto.billing.private.subscription.PricingModelType}
 */
proto.billing.private.subscription.Addon.prototype.getPricingModelType = function() {
  return /** @type {!proto.billing.private.subscription.PricingModelType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.billing.private.subscription.PricingModelType} value
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.setPricingModelType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated AddonPriceModel add_on_price_models = 9;
 * @return {!Array<!proto.billing.private.subscription.AddonPriceModel>}
 */
proto.billing.private.subscription.Addon.prototype.getAddOnPriceModelsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.AddonPriceModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.AddonPriceModel, 9));
};


/**
 * @param {!Array<!proto.billing.private.subscription.AddonPriceModel>} value
 * @return {!proto.billing.private.subscription.Addon} returns this
*/
proto.billing.private.subscription.Addon.prototype.setAddOnPriceModelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.billing.private.subscription.AddonPriceModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.AddonPriceModel}
 */
proto.billing.private.subscription.Addon.prototype.addAddOnPriceModels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.billing.private.subscription.AddonPriceModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.Addon} returns this
 */
proto.billing.private.subscription.Addon.prototype.clearAddOnPriceModelsList = function() {
  return this.setAddOnPriceModelsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.AddonPriceModel.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.AddonPriceModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.AddonPriceModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AddonPriceModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    frequency: jspb.Message.getFieldWithDefault(msg, 3, 0),
    frequencyType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    flatFeePrice: (f = msg.getFlatFeePrice()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    flatFeePriceFormatted: jspb.Message.getFieldWithDefault(msg, 6, ""),
    perUnitPrice: (f = msg.getPerUnitPrice()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    perUnitPriceFormatted: jspb.Message.getFieldWithDefault(msg, 8, ""),
    currency: (f = msg.getCurrency()) && proto.billing.private.subscription.Currency.toObject(includeInstance, f),
    tiersList: jspb.Message.toObjectList(msg.getTiersList(),
    proto.billing.private.subscription.UnitTier.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.AddonPriceModel}
 */
proto.billing.private.subscription.AddonPriceModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.AddonPriceModel;
  return proto.billing.private.subscription.AddonPriceModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.AddonPriceModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.AddonPriceModel}
 */
proto.billing.private.subscription.AddonPriceModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrequency(value);
      break;
    case 4:
      var value = /** @type {!proto.billing.private.subscription.FrequencyType} */ (reader.readEnum());
      msg.setFrequencyType(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setFlatFeePrice(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlatFeePriceFormatted(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPerUnitPrice(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerUnitPriceFormatted(value);
      break;
    case 9:
      var value = new proto.billing.private.subscription.Currency;
      reader.readMessage(value,proto.billing.private.subscription.Currency.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 10:
      var value = new proto.billing.private.subscription.UnitTier;
      reader.readMessage(value,proto.billing.private.subscription.UnitTier.deserializeBinaryFromReader);
      msg.addTiers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.AddonPriceModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.AddonPriceModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AddonPriceModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFrequency();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFrequencyType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getFlatFeePrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getFlatFeePriceFormatted();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPerUnitPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getPerUnitPriceFormatted();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.billing.private.subscription.Currency.serializeBinaryToWriter
    );
  }
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.billing.private.subscription.UnitTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 frequency = 3;
 * @return {number}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getFrequency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional FrequencyType frequency_type = 4;
 * @return {!proto.billing.private.subscription.FrequencyType}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getFrequencyType = function() {
  return /** @type {!proto.billing.private.subscription.FrequencyType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.billing.private.subscription.FrequencyType} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.setFrequencyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Int32Value flat_fee_price = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getFlatFeePrice = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
*/
proto.billing.private.subscription.AddonPriceModel.prototype.setFlatFeePrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.clearFlatFeePrice = function() {
  return this.setFlatFeePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.hasFlatFeePrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string flat_fee_price_formatted = 6;
 * @return {string}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getFlatFeePriceFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.setFlatFeePriceFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Int32Value per_unit_price = 7;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getPerUnitPrice = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 7));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
*/
proto.billing.private.subscription.AddonPriceModel.prototype.setPerUnitPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.clearPerUnitPrice = function() {
  return this.setPerUnitPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.hasPerUnitPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string per_unit_price_formatted = 8;
 * @return {string}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getPerUnitPriceFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.setPerUnitPriceFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Currency currency = 9;
 * @return {?proto.billing.private.subscription.Currency}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getCurrency = function() {
  return /** @type{?proto.billing.private.subscription.Currency} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.Currency, 9));
};


/**
 * @param {?proto.billing.private.subscription.Currency|undefined} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
*/
proto.billing.private.subscription.AddonPriceModel.prototype.setCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated UnitTier tiers = 10;
 * @return {!Array<!proto.billing.private.subscription.UnitTier>}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.getTiersList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.UnitTier>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.UnitTier, 10));
};


/**
 * @param {!Array<!proto.billing.private.subscription.UnitTier>} value
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
*/
proto.billing.private.subscription.AddonPriceModel.prototype.setTiersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.billing.private.subscription.UnitTier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.UnitTier}
 */
proto.billing.private.subscription.AddonPriceModel.prototype.addTiers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.billing.private.subscription.UnitTier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.AddonPriceModel} returns this
 */
proto.billing.private.subscription.AddonPriceModel.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UnitTier.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UnitTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UnitTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UnitTier.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    finish: jspb.Message.getFieldWithDefault(msg, 2, 0),
    price: jspb.Message.getFieldWithDefault(msg, 3, 0),
    priceFormatted: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UnitTier}
 */
proto.billing.private.subscription.UnitTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UnitTier;
  return proto.billing.private.subscription.UnitTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UnitTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UnitTier}
 */
proto.billing.private.subscription.UnitTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFinish(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceFormatted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UnitTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UnitTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UnitTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UnitTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFinish();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPriceFormatted();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 start = 1;
 * @return {number}
 */
proto.billing.private.subscription.UnitTier.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UnitTier} returns this
 */
proto.billing.private.subscription.UnitTier.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 finish = 2;
 * @return {number}
 */
proto.billing.private.subscription.UnitTier.prototype.getFinish = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UnitTier} returns this
 */
proto.billing.private.subscription.UnitTier.prototype.setFinish = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 price = 3;
 * @return {number}
 */
proto.billing.private.subscription.UnitTier.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UnitTier} returns this
 */
proto.billing.private.subscription.UnitTier.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string price_formatted = 4;
 * @return {string}
 */
proto.billing.private.subscription.UnitTier.prototype.getPriceFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.UnitTier} returns this
 */
proto.billing.private.subscription.UnitTier.prototype.setPriceFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    subscriptionAddonsList: jspb.Message.toObjectList(msg.getSubscriptionAddonsList(),
    proto.billing.private.subscription.SubscriptionAddon.toObject, includeInstance),
    requestedByUserId: (f = msg.getRequestedByUserId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UpdateSubscriptionAddonsRequest;
  return proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = new proto.billing.private.subscription.SubscriptionAddon;
      reader.readMessage(value,proto.billing.private.subscription.SubscriptionAddon.deserializeBinaryFromReader);
      msg.addSubscriptionAddons(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRequestedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSubscriptionAddonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.billing.private.subscription.SubscriptionAddon.serializeBinaryToWriter
    );
  }
  f = message.getRequestedByUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated SubscriptionAddon subscription_addons = 3;
 * @return {!Array<!proto.billing.private.subscription.SubscriptionAddon>}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.getSubscriptionAddonsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.SubscriptionAddon>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.SubscriptionAddon, 3));
};


/**
 * @param {!Array<!proto.billing.private.subscription.SubscriptionAddon>} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} returns this
*/
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.setSubscriptionAddonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.billing.private.subscription.SubscriptionAddon=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.SubscriptionAddon}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.addSubscriptionAddons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billing.private.subscription.SubscriptionAddon, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.clearSubscriptionAddonsList = function() {
  return this.setSubscriptionAddonsList([]);
};


/**
 * optional google.protobuf.Int32Value requested_by_user_id = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.getRequestedByUserId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} returns this
*/
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.clearRequestedByUserId = function() {
  return this.setRequestedByUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsRequest.prototype.hasRequestedByUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAddonsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsResponse}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UpdateSubscriptionAddonsResponse;
  return proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAddonsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsResponse}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAddonsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAddonsResponse} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAddonsResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.SubscriptionAddon.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.SubscriptionAddon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.SubscriptionAddon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.SubscriptionAddon.toObject = function(includeInstance, msg) {
  var f, obj = {
    addonId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.SubscriptionAddon}
 */
proto.billing.private.subscription.SubscriptionAddon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.SubscriptionAddon;
  return proto.billing.private.subscription.SubscriptionAddon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.SubscriptionAddon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.SubscriptionAddon}
 */
proto.billing.private.subscription.SubscriptionAddon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddonId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.SubscriptionAddon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.SubscriptionAddon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.SubscriptionAddon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.SubscriptionAddon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddonId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 addon_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.SubscriptionAddon.prototype.getAddonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.SubscriptionAddon} returns this
 */
proto.billing.private.subscription.SubscriptionAddon.prototype.setAddonId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.billing.private.subscription.SubscriptionAddon.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.SubscriptionAddon} returns this
 */
proto.billing.private.subscription.SubscriptionAddon.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.CheckoutAddonsSimulationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscriptionUniqueId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subscriptionAddonsList: jspb.Message.toObjectList(msg.getSubscriptionAddonsList(),
    proto.billing.private.subscription.SubscriptionAddon.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.CheckoutAddonsSimulationRequest;
  return proto.billing.private.subscription.CheckoutAddonsSimulationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionUniqueId(value);
      break;
    case 3:
      var value = new proto.billing.private.subscription.SubscriptionAddon;
      reader.readMessage(value,proto.billing.private.subscription.SubscriptionAddon.deserializeBinaryFromReader);
      msg.addSubscriptionAddons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.CheckoutAddonsSimulationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionUniqueId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionAddonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.billing.private.subscription.SubscriptionAddon.serializeBinaryToWriter
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_unique_id = 2;
 * @return {string}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.getSubscriptionUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.setSubscriptionUniqueId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SubscriptionAddon subscription_addons = 3;
 * @return {!Array<!proto.billing.private.subscription.SubscriptionAddon>}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.getSubscriptionAddonsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.SubscriptionAddon>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.SubscriptionAddon, 3));
};


/**
 * @param {!Array<!proto.billing.private.subscription.SubscriptionAddon>} value
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} returns this
*/
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.setSubscriptionAddonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.billing.private.subscription.SubscriptionAddon=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.SubscriptionAddon}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.addSubscriptionAddons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billing.private.subscription.SubscriptionAddon, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAddonsSimulationRequest.prototype.clearSubscriptionAddonsList = function() {
  return this.setSubscriptionAddonsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.CheckoutAddonsSimulationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    priceSimulationsList: jspb.Message.toObjectList(msg.getPriceSimulationsList(),
    proto.billing.private.subscription.AddonPriceSimulation.toObject, includeInstance),
    totalAmount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalAmountFormatted: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.CheckoutAddonsSimulationResponse;
  return proto.billing.private.subscription.CheckoutAddonsSimulationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.subscription.AddonPriceSimulation;
      reader.readMessage(value,proto.billing.private.subscription.AddonPriceSimulation.deserializeBinaryFromReader);
      msg.addPriceSimulations(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalAmountFormatted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.CheckoutAddonsSimulationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceSimulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billing.private.subscription.AddonPriceSimulation.serializeBinaryToWriter
    );
  }
  f = message.getTotalAmount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalAmountFormatted();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated AddonPriceSimulation price_simulations = 1;
 * @return {!Array<!proto.billing.private.subscription.AddonPriceSimulation>}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.getPriceSimulationsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.AddonPriceSimulation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.AddonPriceSimulation, 1));
};


/**
 * @param {!Array<!proto.billing.private.subscription.AddonPriceSimulation>} value
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} returns this
*/
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.setPriceSimulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billing.private.subscription.AddonPriceSimulation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.AddonPriceSimulation}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.addPriceSimulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing.private.subscription.AddonPriceSimulation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} returns this
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.clearPriceSimulationsList = function() {
  return this.setPriceSimulationsList([]);
};


/**
 * optional int32 total_amount = 2;
 * @return {number}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.getTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} returns this
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.setTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string total_amount_formatted = 3;
 * @return {string}
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.getTotalAmountFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.CheckoutAddonsSimulationResponse} returns this
 */
proto.billing.private.subscription.CheckoutAddonsSimulationResponse.prototype.setTotalAmountFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.AddonPriceSimulation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.AddonPriceSimulation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AddonPriceSimulation.toObject = function(includeInstance, msg) {
  var f, obj = {
    addonId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amountFormatted: jspb.Message.getFieldWithDefault(msg, 3, ""),
    regularAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    regularAmountFormatted: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.AddonPriceSimulation}
 */
proto.billing.private.subscription.AddonPriceSimulation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.AddonPriceSimulation;
  return proto.billing.private.subscription.AddonPriceSimulation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.AddonPriceSimulation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.AddonPriceSimulation}
 */
proto.billing.private.subscription.AddonPriceSimulation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddonId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmountFormatted(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRegularAmount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegularAmountFormatted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.AddonPriceSimulation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.AddonPriceSimulation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AddonPriceSimulation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddonId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAmountFormatted();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegularAmount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRegularAmountFormatted();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 addon_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.getAddonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AddonPriceSimulation} returns this
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.setAddonId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 amount = 2;
 * @return {number}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AddonPriceSimulation} returns this
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string amount_formatted = 3;
 * @return {string}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.getAmountFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AddonPriceSimulation} returns this
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.setAmountFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 regular_amount = 4;
 * @return {number}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.getRegularAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AddonPriceSimulation} returns this
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.setRegularAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string regular_amount_formatted = 5;
 * @return {string}
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.getRegularAmountFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AddonPriceSimulation} returns this
 */
proto.billing.private.subscription.AddonPriceSimulation.prototype.setRegularAmountFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscriptionUniqueId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subscriptionAllowancesIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.CheckoutAllowancesSimulationRequest;
  return proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionUniqueId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSubscriptionAllowancesIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionUniqueId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionAllowancesIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_unique_id = 2;
 * @return {string}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.getSubscriptionUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.setSubscriptionUniqueId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated int32 subscription_allowances_ids = 3;
 * @return {!Array<number>}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.getSubscriptionAllowancesIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.setSubscriptionAllowancesIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.addSubscriptionAllowancesIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationRequest} returns this
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationRequest.prototype.clearSubscriptionAllowancesIdsList = function() {
  return this.setSubscriptionAllowancesIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    priceSimulationsList: jspb.Message.toObjectList(msg.getPriceSimulationsList(),
    proto.billing.private.subscription.AllowancePriceSimulation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.CheckoutAllowancesSimulationResponse;
  return proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.subscription.AllowancePriceSimulation;
      reader.readMessage(value,proto.billing.private.subscription.AllowancePriceSimulation.deserializeBinaryFromReader);
      msg.addPriceSimulations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceSimulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billing.private.subscription.AllowancePriceSimulation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AllowancePriceSimulation price_simulations = 1;
 * @return {!Array<!proto.billing.private.subscription.AllowancePriceSimulation>}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.prototype.getPriceSimulationsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.AllowancePriceSimulation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.AllowancePriceSimulation, 1));
};


/**
 * @param {!Array<!proto.billing.private.subscription.AllowancePriceSimulation>} value
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse} returns this
*/
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.prototype.setPriceSimulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billing.private.subscription.AllowancePriceSimulation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation}
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.prototype.addPriceSimulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing.private.subscription.AllowancePriceSimulation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.CheckoutAllowancesSimulationResponse} returns this
 */
proto.billing.private.subscription.CheckoutAllowancesSimulationResponse.prototype.clearPriceSimulationsList = function() {
  return this.setPriceSimulationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.AllowancePriceSimulation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.AllowancePriceSimulation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AllowancePriceSimulation.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowanceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    regularIncludedUnits: (f = msg.getRegularIncludedUnits()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    proratedIncludedUnits: (f = msg.getProratedIncludedUnits()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation}
 */
proto.billing.private.subscription.AllowancePriceSimulation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.AllowancePriceSimulation;
  return proto.billing.private.subscription.AllowancePriceSimulation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.AllowancePriceSimulation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation}
 */
proto.billing.private.subscription.AllowancePriceSimulation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAllowanceId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRegularIncludedUnits(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setProratedIncludedUnits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.AllowancePriceSimulation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.AllowancePriceSimulation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AllowancePriceSimulation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowanceId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRegularIncludedUnits();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getProratedIncludedUnits();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 allowance_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.getAllowanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation} returns this
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.setAllowanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value regular_included_units = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.getRegularIncludedUnits = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation} returns this
*/
proto.billing.private.subscription.AllowancePriceSimulation.prototype.setRegularIncludedUnits = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation} returns this
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.clearRegularIncludedUnits = function() {
  return this.setRegularIncludedUnits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.hasRegularIncludedUnits = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value prorated_included_units = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.getProratedIncludedUnits = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation} returns this
*/
proto.billing.private.subscription.AllowancePriceSimulation.prototype.setProratedIncludedUnits = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AllowancePriceSimulation} returns this
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.clearProratedIncludedUnits = function() {
  return this.setProratedIncludedUnits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AllowancePriceSimulation.prototype.hasProratedIncludedUnits = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    subscriptionAllowancesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    requestedByUserId: (f = msg.getRequestedByUserId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest;
  return proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSubscriptionAllowances(values[i]);
      }
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRequestedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSubscriptionAllowancesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getRequestedByUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int32 subscription_allowances = 3;
 * @return {!Array<number>}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.getSubscriptionAllowancesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.setSubscriptionAllowancesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.addSubscriptionAllowances = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.clearSubscriptionAllowancesList = function() {
  return this.setSubscriptionAllowancesList([]);
};


/**
 * optional google.protobuf.Int32Value requested_by_user_id = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.getRequestedByUserId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
*/
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.clearRequestedByUserId = function() {
  return this.setRequestedByUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceRequest.prototype.hasRequestedByUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse;
  return proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionAllowanceResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    allowanceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestedByUserId: (f = msg.getRequestedByUserId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest;
  return proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAllowanceId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRequestedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAllowanceId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRequestedByUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 allowance_id = 3;
 * @return {number}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.getAllowanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.setAllowanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value requested_by_user_id = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.getRequestedByUserId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} returns this
*/
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.clearRequestedByUserId = function() {
  return this.setRequestedByUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceRequest.prototype.hasRequestedByUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse;
  return proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse} returns this
 */
proto.billing.private.subscription.DeleteSubscriptionAllowanceResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.GetAllowancesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.GetAllowancesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.GetAllowancesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAllowancesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.GetAllowancesRequest}
 */
proto.billing.private.subscription.GetAllowancesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.GetAllowancesRequest;
  return proto.billing.private.subscription.GetAllowancesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.GetAllowancesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.GetAllowancesRequest}
 */
proto.billing.private.subscription.GetAllowancesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.GetAllowancesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.GetAllowancesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.GetAllowancesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAllowancesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.GetAllowancesRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetAllowancesRequest} returns this
 */
proto.billing.private.subscription.GetAllowancesRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_id = 2;
 * @return {number}
 */
proto.billing.private.subscription.GetAllowancesRequest.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.GetAllowancesRequest} returns this
 */
proto.billing.private.subscription.GetAllowancesRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.GetAllowancesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.GetAllowancesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.GetAllowancesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.GetAllowancesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAllowancesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowancesList: jspb.Message.toObjectList(msg.getAllowancesList(),
    proto.billing.private.subscription.Allowance.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.GetAllowancesResponse}
 */
proto.billing.private.subscription.GetAllowancesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.GetAllowancesResponse;
  return proto.billing.private.subscription.GetAllowancesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.GetAllowancesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.GetAllowancesResponse}
 */
proto.billing.private.subscription.GetAllowancesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.subscription.Allowance;
      reader.readMessage(value,proto.billing.private.subscription.Allowance.deserializeBinaryFromReader);
      msg.addAllowances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.GetAllowancesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.GetAllowancesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.GetAllowancesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.GetAllowancesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billing.private.subscription.Allowance.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Allowance allowances = 1;
 * @return {!Array<!proto.billing.private.subscription.Allowance>}
 */
proto.billing.private.subscription.GetAllowancesResponse.prototype.getAllowancesList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.Allowance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.Allowance, 1));
};


/**
 * @param {!Array<!proto.billing.private.subscription.Allowance>} value
 * @return {!proto.billing.private.subscription.GetAllowancesResponse} returns this
*/
proto.billing.private.subscription.GetAllowancesResponse.prototype.setAllowancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billing.private.subscription.Allowance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.Allowance}
 */
proto.billing.private.subscription.GetAllowancesResponse.prototype.addAllowances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing.private.subscription.Allowance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.GetAllowancesResponse} returns this
 */
proto.billing.private.subscription.GetAllowancesResponse.prototype.clearAllowancesList = function() {
  return this.setAllowancesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.Allowance.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.Allowance.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.Allowance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.Allowance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.Allowance.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    singleUnitName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    pluralUnitName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    addedOn: (f = msg.getAddedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    willBeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    isForced: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    pricingModelType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    allowancePriceModelsList: jspb.Message.toObjectList(msg.getAllowancePriceModelsList(),
    proto.billing.private.subscription.AllowancePriceModel.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.Allowance}
 */
proto.billing.private.subscription.Allowance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.Allowance;
  return proto.billing.private.subscription.Allowance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.Allowance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.Allowance}
 */
proto.billing.private.subscription.Allowance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSingleUnitName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPluralUnitName(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAddedOn(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWillBeDeleted(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsForced(value);
      break;
    case 11:
      var value = /** @type {!proto.billing.private.subscription.PricingModelType} */ (reader.readEnum());
      msg.setPricingModelType(value);
      break;
    case 12:
      var value = new proto.billing.private.subscription.AllowancePriceModel;
      reader.readMessage(value,proto.billing.private.subscription.AllowancePriceModel.deserializeBinaryFromReader);
      msg.addAllowancePriceModels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.Allowance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.Allowance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.Allowance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.Allowance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSingleUnitName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPluralUnitName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddedOn();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWillBeDeleted();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsForced();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPricingModelType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getAllowancePriceModelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.billing.private.subscription.AllowancePriceModel.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.billing.private.subscription.Allowance.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billing.private.subscription.Allowance.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.billing.private.subscription.Allowance.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.billing.private.subscription.Allowance.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.billing.private.subscription.Allowance.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string single_unit_name = 6;
 * @return {string}
 */
proto.billing.private.subscription.Allowance.prototype.getSingleUnitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setSingleUnitName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string plural_unit_name = 7;
 * @return {string}
 */
proto.billing.private.subscription.Allowance.prototype.getPluralUnitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setPluralUnitName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp added_on = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.subscription.Allowance.prototype.getAddedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
*/
proto.billing.private.subscription.Allowance.prototype.setAddedOn = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.clearAddedOn = function() {
  return this.setAddedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.Allowance.prototype.hasAddedOn = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool will_be_deleted = 9;
 * @return {boolean}
 */
proto.billing.private.subscription.Allowance.prototype.getWillBeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setWillBeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool is_forced = 10;
 * @return {boolean}
 */
proto.billing.private.subscription.Allowance.prototype.getIsForced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setIsForced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional PricingModelType pricing_model_type = 11;
 * @return {!proto.billing.private.subscription.PricingModelType}
 */
proto.billing.private.subscription.Allowance.prototype.getPricingModelType = function() {
  return /** @type {!proto.billing.private.subscription.PricingModelType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.billing.private.subscription.PricingModelType} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.setPricingModelType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * repeated AllowancePriceModel allowance_price_models = 12;
 * @return {!Array<!proto.billing.private.subscription.AllowancePriceModel>}
 */
proto.billing.private.subscription.Allowance.prototype.getAllowancePriceModelsList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.AllowancePriceModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.AllowancePriceModel, 12));
};


/**
 * @param {!Array<!proto.billing.private.subscription.AllowancePriceModel>} value
 * @return {!proto.billing.private.subscription.Allowance} returns this
*/
proto.billing.private.subscription.Allowance.prototype.setAllowancePriceModelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.billing.private.subscription.AllowancePriceModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.AllowancePriceModel}
 */
proto.billing.private.subscription.Allowance.prototype.addAllowancePriceModels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.billing.private.subscription.AllowancePriceModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.Allowance} returns this
 */
proto.billing.private.subscription.Allowance.prototype.clearAllowancePriceModelsList = function() {
  return this.setAllowancePriceModelsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.subscription.AllowancePriceModel.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.AllowancePriceModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.AllowancePriceModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AllowancePriceModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    frequency: jspb.Message.getFieldWithDefault(msg, 3, 0),
    frequencyType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    includedUnits: (f = msg.getIncludedUnits()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    perUnitPrice: jspb.Message.getFieldWithDefault(msg, 7, ""),
    perUnitPriceFormatted: jspb.Message.getFieldWithDefault(msg, 8, ""),
    currency: (f = msg.getCurrency()) && proto.billing.private.subscription.Currency.toObject(includeInstance, f),
    tiersList: jspb.Message.toObjectList(msg.getTiersList(),
    proto.billing.private.subscription.UnitTier.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.AllowancePriceModel}
 */
proto.billing.private.subscription.AllowancePriceModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.AllowancePriceModel;
  return proto.billing.private.subscription.AllowancePriceModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.AllowancePriceModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.AllowancePriceModel}
 */
proto.billing.private.subscription.AllowancePriceModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrequency(value);
      break;
    case 4:
      var value = /** @type {!proto.billing.private.subscription.FrequencyType} */ (reader.readEnum());
      msg.setFrequencyType(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setIncludedUnits(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerUnitPrice(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerUnitPriceFormatted(value);
      break;
    case 9:
      var value = new proto.billing.private.subscription.Currency;
      reader.readMessage(value,proto.billing.private.subscription.Currency.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 10:
      var value = new proto.billing.private.subscription.UnitTier;
      reader.readMessage(value,proto.billing.private.subscription.UnitTier.deserializeBinaryFromReader);
      msg.addTiers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.AllowancePriceModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.AllowancePriceModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.AllowancePriceModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFrequency();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFrequencyType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getIncludedUnits();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getPerUnitPrice();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPerUnitPriceFormatted();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.billing.private.subscription.Currency.serializeBinaryToWriter
    );
  }
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.billing.private.subscription.UnitTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 frequency = 3;
 * @return {number}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getFrequency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional FrequencyType frequency_type = 4;
 * @return {!proto.billing.private.subscription.FrequencyType}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getFrequencyType = function() {
  return /** @type {!proto.billing.private.subscription.FrequencyType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.billing.private.subscription.FrequencyType} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.setFrequencyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Int32Value included_units = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getIncludedUnits = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
*/
proto.billing.private.subscription.AllowancePriceModel.prototype.setIncludedUnits = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.clearIncludedUnits = function() {
  return this.setIncludedUnits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.hasIncludedUnits = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string per_unit_price = 7;
 * @return {string}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getPerUnitPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.setPerUnitPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string per_unit_price_formatted = 8;
 * @return {string}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getPerUnitPriceFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.setPerUnitPriceFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Currency currency = 9;
 * @return {?proto.billing.private.subscription.Currency}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getCurrency = function() {
  return /** @type{?proto.billing.private.subscription.Currency} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.subscription.Currency, 9));
};


/**
 * @param {?proto.billing.private.subscription.Currency|undefined} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
*/
proto.billing.private.subscription.AllowancePriceModel.prototype.setCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated UnitTier tiers = 10;
 * @return {!Array<!proto.billing.private.subscription.UnitTier>}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.getTiersList = function() {
  return /** @type{!Array<!proto.billing.private.subscription.UnitTier>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.subscription.UnitTier, 10));
};


/**
 * @param {!Array<!proto.billing.private.subscription.UnitTier>} value
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
*/
proto.billing.private.subscription.AllowancePriceModel.prototype.setTiersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.billing.private.subscription.UnitTier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.subscription.UnitTier}
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.addTiers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.billing.private.subscription.UnitTier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.subscription.AllowancePriceModel} returns this
 */
proto.billing.private.subscription.AllowancePriceModel.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.Currency.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.Currency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.Currency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.Currency.toObject = function(includeInstance, msg) {
  var f, obj = {
    englishName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    iso3Code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hasDecimal: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.Currency}
 */
proto.billing.private.subscription.Currency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.Currency;
  return proto.billing.private.subscription.Currency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.Currency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.Currency}
 */
proto.billing.private.subscription.Currency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnglishName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIso3Code(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasDecimal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.Currency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.Currency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.Currency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.Currency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnglishName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIso3Code();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHasDecimal();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string english_name = 1;
 * @return {string}
 */
proto.billing.private.subscription.Currency.prototype.getEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Currency} returns this
 */
proto.billing.private.subscription.Currency.prototype.setEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string iso_3_code = 2;
 * @return {string}
 */
proto.billing.private.subscription.Currency.prototype.getIso3Code = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Currency} returns this
 */
proto.billing.private.subscription.Currency.prototype.setIso3Code = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.billing.private.subscription.Currency.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.Currency} returns this
 */
proto.billing.private.subscription.Currency.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool has_decimal = 4;
 * @return {boolean}
 */
proto.billing.private.subscription.Currency.prototype.getHasDecimal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.Currency} returns this
 */
proto.billing.private.subscription.Currency.prototype.setHasDecimal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UpdateSubscriptionStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionUniqueId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestedByUserId: (f = msg.getRequestedByUserId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UpdateSubscriptionStatusRequest;
  return proto.billing.private.subscription.UpdateSubscriptionStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionUniqueId(value);
      break;
    case 3:
      var value = /** @type {!proto.billing.private.subscription.SubscriptionStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRequestedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UpdateSubscriptionStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionUniqueId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRequestedByUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string subscription_unique_id = 2;
 * @return {string}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.getSubscriptionUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.setSubscriptionUniqueId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SubscriptionStatus status = 3;
 * @return {!proto.billing.private.subscription.SubscriptionStatus}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.billing.private.subscription.SubscriptionStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.billing.private.subscription.SubscriptionStatus} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value requested_by_user_id = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.getRequestedByUserId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} returns this
*/
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.setRequestedByUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusRequest} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.clearRequestedByUserId = function() {
  return this.setRequestedByUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusRequest.prototype.hasRequestedByUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.subscription.UpdateSubscriptionStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.subscription.UpdateSubscriptionStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusResponse}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.subscription.UpdateSubscriptionStatusResponse;
  return proto.billing.private.subscription.UpdateSubscriptionStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusResponse}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.subscription.UpdateSubscriptionStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.subscription.UpdateSubscriptionStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.subscription.UpdateSubscriptionStatusResponse} returns this
 */
proto.billing.private.subscription.UpdateSubscriptionStatusResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.billing.private.subscription.FrequencyType = {
  UNSPECIFIED_FT: 0,
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
  YEARLY: 4
};

/**
 * @enum {number}
 */
proto.billing.private.subscription.PricingModelType = {
  UNSPECIFIED_PMT: 0,
  FLATFEE: 1,
  PERUNIT: 2,
  RESERVED: 3,
  TIERED: 4,
  VOLUME: 5,
  RANGED: 6,
  CAPPED: 7
};

/**
 * @enum {number}
 */
proto.billing.private.subscription.SubscriptionStatus = {
  UNSPECIFIED: 0,
  CANCELLED: 1,
  ACTIVE: 2,
  PAUSED: 3,
  SUSPENDED: 4,
  IN_TRIAL: 5
};

goog.object.extend(exports, proto.billing.private.subscription);
